import { Box, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { sections } from '../data/homepage';
import { getFeaturedUpdates } from '../data/updatesData';
import { UpdateCard, UpdatesHeading } from './atomic';
import { StyledButton } from './ui';

/**
 * EBooksSection2 - Full width eBooks layout
 *
 * @returns {JSX.Element} eBooks section with full width layout
 */
function EBooksSection2() {
  const navigate = useNavigate();

  // Get featured updates from shared data source
  const ebooks = getFeaturedUpdates();

  return (
    <Box
      sx={{
        width: '100vw',
        backgroundColor: 'var(--color-background-light)',
        position: 'relative',
        left: '50%',
        right: '50%',
        marginLeft: '-50vw',
        marginRight: '-50vw',
      }}
    >
      {/* Header with dark theme */}
      <Box
        sx={{
          borderTop: '4px solid var(--color-primary)',
          borderBottom: '4px solid var(--color-primary)',
          backgroundColor: 'var(--color-secondary)',
          py: 4,
          mb: 6,
        }}
      >
        <UpdatesHeading />
      </Box>

      {/* Description text - outside the black header */}
      <Typography
        variant="body2"
        sx={{
          color: 'var(--color-text-muted)',
          fontSize: '0.95rem',
          maxWidth: '900px',
          mx: 'auto',
          mt: 4,
          mb: 4,
          px: { xs: 2, md: 0 },
          textAlign: 'center',
        }}
      >
        {sections.updates.description}
      </Typography>

      {/* Main content area with proper container alignment */}
      <Container maxWidth="lg" sx={{ pb: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            width: '100%',
          }}
        >
          {/* First row - 3 items */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))',
              },
              gap: 3,
            }}
          >
            {ebooks.slice(0, 3).map((ebook, index) => (
              <UpdateCard
                key={`${ebook.title}-${index}`}
                {...ebook}
                index={index}
              />
            ))}
          </Box>

          {/* Second row - 3 items */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: {
                xs: '1fr',
                sm: 'repeat(2, minmax(0, 1fr))',
                md: 'repeat(3, minmax(0, 1fr))',
              },
              gap: 3,
            }}
          >
            {ebooks.slice(3, 6).map((ebook, index) => (
              <UpdateCard
                key={`${ebook.title}-row2-${index}`}
                {...ebook}
                index={index + 3}
              />
            ))}
          </Box>

          {/* See All Button */}
          <Box sx={{ textAlign: 'center', mt: 4 }}>
            <StyledButton
              variant="contained"
              onClick={() => navigate('/updates')}
              sx={{
                backgroundColor: 'var(--color-primary)',
                color: 'var(--color-primary-text)',
                px: 4,
                py: 1.5,
                fontSize: '1rem',
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: 'var(--color-primary-dark)',
                },
              }}
            >
              See All
            </StyledButton>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default EBooksSection2;
